/**
 * Investor Gate
 *
 * Accept → hides #gate, sets sessionStorage.gate_passed = '1'.
 * Decline → replaces .gate-modal innerHTML with the decline template; gate stays visible.
 * No inline onclick — all listeners attached here.
 */

export const investorGate = () => {
	const gate = document.getElementById( 'gate' )
	if ( ! gate ) return

	const acceptBtn  = gate.querySelector( '[data-gate-action="accept"]' )
	const declineBtn = gate.querySelector( '[data-gate-action="decline"]' )
	const declineTpl = document.getElementById( 'gate-decline-tpl' )

	const handleAccept = () => {
		gate.style.display = 'none'
		try {
			sessionStorage.setItem( 'gate_passed', '1' )
		} catch ( e ) {}
	}

	const handleDecline = () => {
		const modal = gate.querySelector( '.gate-modal' )
		if ( modal && declineTpl ) {
			modal.innerHTML = declineTpl.innerHTML
		}
	}

	if ( acceptBtn )  acceptBtn.addEventListener(  'click', handleAccept  )
	if ( declineBtn ) declineBtn.addEventListener( 'click', handleDecline )
}
